import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Childcare = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my childcare business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps childcare businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for childcare businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most childcare businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my childcare business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like childcare. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Childcare - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Childcare CRM", url: "/industries/childcare" }
  ];

  const industryData = {
    name: 'Childcare & Daycare',
    title: 'Fill Enrollment & Keep Parents Informed Effortlessly',
    subtitle: 'Automate parent communication, manage waitlists, and build a thriving childcare community',
    icon: '👶',
    challenges: [
      'Waitlist management is chaotic',
      'Parents want constant updates',
      'Enrollment drops after summer',
      'Difficult to communicate with all parents',
      'Tour scheduling is time-consuming'
    ],
    solutions: [
      'Automated waitlist and enrollment',
      'Daily activity photo/update automation',
      'Seasonal enrollment campaigns',
      'Mass parent communication',
      'Online tour booking'
    ],
    features: [
      'Parent portal with daily updates',
      'Waitlist automation',
      'Tour scheduling',
      'Billing automation',
      'Daily activity reports',
      'Emergency contact management',
      'Enrollment tracking',
      'Review requests'
    ],
    results: [
      '95% enrollment capacity',
      'Waitlist of 20+ families',
      '90% parent satisfaction',
      '£4.5K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Childcare UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for childcare businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for childcare UK, childcare business software, childcare customer management, childcare lead generation UK"
        url="/industries/childcare"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Childcare;